import { useEffect } from 'react';

export function usePushNotification(args: any) {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const getRegistration = async () => {
      if ('serviceWorker' in navigator) {
        try {
          const registration = await navigator.serviceWorker.getRegistration();
          if (registration?.active) {
            const serviceWorker = registration.active;
            serviceWorker.postMessage({
              type: 'update_icon',
              payload: { icon: args?.icon },
            });
          }
        } catch (err) {
          console.error('Error getting service worker registration:', err);
        }
      } else {
        console.warn('Service Workers are not supported in this browser.');
      }
    };

    const handleControllerChange = () => {
      getRegistration();
    };

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('controllerchange', handleControllerChange);
    }

    getRegistration();

    return () => {
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.removeEventListener('controllerchange', handleControllerChange);
      }
    };
  }, [args?.icon]);
}
